import { ConfigProvider, App as AntApp } from 'antd';
import enUS from 'antd/locale/en_US';
import zhCN from 'antd/locale/zh_CN';
import { BrowserRouter } from 'react-router-dom';
import { theme } from './theme';
import AppRoutes from './routes';
import { useTranslation } from 'react-i18next';
import i18n, { resolveLanguage } from './i18n';
import { useMapStore } from './stores/mapStore';

// Debug: 捕获渲染错误
import React from 'react';

class ErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { error: Error | null }
> {
  state = { error: null as Error | null };
  static getDerivedStateFromError(error: Error) { return { error }; }
  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: 40, color: '#ff4d4f', background: '#0a0a0a', minHeight: '100vh' }}>
          <h2>{i18n.t('Rendering error')}</h2>
          <pre style={{ color: '#faad14', whiteSpace: 'pre-wrap' }}>
            {this.state.error.message}
            {'\n\n'}
            {this.state.error.stack}
          </pre>
        </div>
      );
    }
    return this.props.children;
  }
}

function getBasename(): string | undefined {
  const path = window.location.pathname;
  if (path.startsWith('/pv')) return '/pv';
  return undefined;
}

export default function App() {
  const { i18n: i18nInstance } = useTranslation();
  const locale = resolveLanguage(i18nInstance.language) === 'zh' ? zhCN : enUS;
  const initializeDefaultProvider = useMapStore((s) => s.initializeDefaultProvider);
  
  React.useEffect(() => {
    // Initialize default map provider based on language
    initializeDefaultProvider(i18nInstance.language);
  }, [i18nInstance.language, initializeDefaultProvider]);

  return (
    <ErrorBoundary>
      <ConfigProvider theme={theme} locale={locale}>
        <AntApp>
          <BrowserRouter basename={getBasename()} future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <AppRoutes />
          </BrowserRouter>
        </AntApp>
      </ConfigProvider>
    </ErrorBoundary>
  );
}
